module.exports = __webpack_public_path__ + "static/media/image_mask.b92ced13.jpg";